import { Utils } from "@utils/Utils";
import Storage from "./Storage";

export class AccessStorage {
  static setXUserKey(xUserKey) {
    if (!Utils.empty(xUserKey)) {
      Storage.set("olga.account.x-user-key", xUserKey, false);
    } else {
      Storage.remove("olga.account.x-user-key");
      Storage.remove("olga.account.oUser");
    }
  }

  static setAccessToken(accessToken) {
    return typeof Storage != "undefined"
      ? AccessStorage.setXUserKey(accessToken)
      : undefined;
  }

  static getAccessToken() {
    return typeof Storage != "undefined"
      ? Storage.get("olga.account.x-user-key", false)
      : null;
  }

  static setOlgaXUserKey(xUserKey) {
    if (!Utils.empty(xUserKey)) {
      Storage.set("app.account.x-user-key", xUserKey, false);
    } else {
      Storage.remove("app.account.x-user-key");
      Storage.remove("app.account.oUser");
    }
  }

  static setOcdpAccessToken(accessToken) {
    return typeof Storage != "undefined"
      ? AccessStorage.setXUserKey(accessToken)
      : undefined;
  }

  static getOcdpAccessToken() {
    return typeof Storage != "undefined"
      ? Storage.get("app.account.x-user-key", false)
      : null;
  }

  static setXAPIEnv(xApiEnv) {
    if (!Utils.empty(xApiEnv)) {
      Storage.set("olga.account.x-api-env", xApiEnv, false);
    } else {
      Storage.remove("olga.account.x-api-env");
    }
  }

  static getXAPIEnv() {
    return Storage.get("olga.account.x-api-env");
  }
}
